import { render, staticRenderFns } from "./BatchCreateCasesModal.vue?vue&type=template&id=3e740b82"
import script from "./BatchCreateCasesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BatchCreateCasesModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports